/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./buy-item-button.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./buy-item-button.component";
import * as i3 from "../services/shopping.service";
import * as i4 from "../services/alert.service";
import * as i5 from "@angular/router";
var styles_BuyItemButtonComponent = [i0.styles];
var RenderType_BuyItemButtonComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_BuyItemButtonComponent, data: {} });
export { RenderType_BuyItemButtonComponent as RenderType_BuyItemButtonComponent };
export function View_BuyItemButtonComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "button", [["alt", "Buy Tokens"], ["class", "badge badge-primary badge-pill btn btn-sm btn-primary"], ["title", "Buy Tokens"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("click" === en)) {
        var pd_0 = (_co.buyItem($event) !== false);
        ad = (pd_0 && ad);
    } return ad; }, null, null)), (_l()(), i1.ɵted(-1, null, ["Buy"])), (_l()(), i1.ɵted(-1, null, [" "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.buying; _ck(_v, 0, 0, currVal_0); }); }
export function View_BuyItemButtonComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "dac-buy-item-button", [], null, null, null, View_BuyItemButtonComponent_0, RenderType_BuyItemButtonComponent)), i1.ɵdid(1, 114688, null, 0, i2.BuyItemButtonComponent, [i3.ShoppingService, i4.AlertService, i5.Router, i5.ActivatedRoute], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var BuyItemButtonComponentNgFactory = i1.ɵccf("dac-buy-item-button", i2.BuyItemButtonComponent, View_BuyItemButtonComponent_Host_0, { item: "item" }, { click: "click" }, []);
export { BuyItemButtonComponentNgFactory as BuyItemButtonComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/shared/buy-item-button/buy-item-button.component.ngfactory.js.pre-build-optimizer.js